import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { onEnterKeyPress } from 'helpers/Account';
import NetworkLink from 'components/NetworkLink';
import style from './SearchHeader.module.scss';

const SearchHeader = ({ onXClick = () => null }) => {
  const networkIcon = <NetworkLink onClick={onXClick} />;
  return (
    <div className={style.searchHeader}>
      <div className={style.inner}>
        {networkIcon}
        <Link
          onClick={onXClick}
          tabIndex="0"
          aria-label="close search"
          onKeyPress={e => {
            onEnterKeyPress(e, onXClick);
          }}
          className={style.close}
          onlyActiveOnIndex
        />
      </div>
    </div>
  );
};

SearchHeader.propTypes = {
  onXClick: PropTypes.func,
};

export default SearchHeader;
